import { SVGProps } from 'react';

const Serwizz = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#FA541C" rx="32" />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M30.988 16.197a1.28 1.28 0 0 1 1.351-.008l12.857 7.828c.406.247.657.699.66 1.19.004.49-.24.946-.642 1.2l-5.031 3.177 1.363.83 2.617 1.593 1.898 1.155.003.002c2.556 1.542 2.588 5.388.056 6.975L33.9 47.802a1.28 1.28 0 0 1-1.353.009l-14.554-8.867a1.402 1.402 0 0 1-.66-1.19c-.003-.49.24-.946.643-1.2l4.902-3.095-3.313-2.016c-2.953-1.798-2.977-6.248-.044-8.081l11.467-7.165ZM37.59 31.22l1.364.83 2.617 1.594.005.003-1.102.715-4.419 2.76c-.572.358-1.996.256-2.694-.542-.487-.701-.776-2.2.654-3.103l3.575-2.257Zm-4.732 8.315a4.32 4.32 0 0 0 4.56-.027l4.429-2.767h.002l.007-.006h.002l.008-.006 1.542-1 .002-.002c.597-.382 1.01-.346 1.324-.157.802.482.812 1.688.019 2.185l-11.546 7.24-11.94-7.274 4.228-2.669 3.273 1.993 2.365 1.44 1.725 1.05Zm-4.932-6.219 2.553 1.554c.076-1.549.883-2.965 2.161-3.772l9.282-5.86-10.243-6.236-10.794 6.744c-1.196.747-1.186 2.561.018 3.294l7.023 4.276Z"
      clipRule="evenodd"
    />
  </svg>
);

export default Serwizz;
